import { createFileRoute, redirect } from "@tanstack/react-router";
import { getRecordWorkspacePath } from "@/features/jobs/lib/get-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getRecordWorkspacePath({
				orgId: params.orgId,
				jobId: params.jobId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
